import { useQuery } from '@apollo/client/react';
import { Query, QueryVehicleArgs } from '../../../@types/codegen/types';
import SEARCH_ITEM_QUERY from '../Queries/SEARCH_ITEM_QUERY';

const useSearchItem = (id?: string) =>
  useQuery<Query, QueryVehicleArgs>(SEARCH_ITEM_QUERY, {
    variables: { id: id as string },
    skip: !id,
  });

export default useSearchItem;
